import FacebookLogo from './facebook_logo.svg'
import GoogleLogo from './google_logo.svg'

export const icons = {
  FacebookLogo,
  GoogleLogo,
}
